<template>
  <main>
    <div class="container">
      <div class="main-content-box">
        <div class="top-page-divider">
          <h3 class="page-title center">Xalor Rules</h3>
          <p>Community Rules & Regulations</p>
        </div>
        <div class="row">
          <div class="col-12 col-md-4 col-lg-3">
            <h5 class="content-box--heading">Contents</h5>
            <div class="table-of-contents">
              <ul>
                <li><a href="#1">1. Flaming, Racism, Harassment, and Disrespect</a></li>
                <li><a href="#2">2. Doxing / Sharing Personal Information</a></li>
                <li><a href="#3">3. Advertising Other Servers</a></li>
                <li><a href="#4">4. Spamming</a></li>
                <li><a href="#5">5. Hacking & Threats</a></li>
                <li><a href="#6">6. Encouraging Others to Break Rules</a></li>
                <li><a href="#7">7. Bug Abuse</a></li>
                <li><a href="#8">8. Player vs Player (PvP)</a></li>
                <li><a href="#9">9. Third-Party Software</a></li>
                <li><a href="#10">10. Impersonation</a></li>
                <li><a href="#11">11. Scams, Gambling & Refunds</a></li>
                <li><a href="#12">12. Real-World Trading (RWT)</a></li>
                <li><a href="#13">13. Services</a></li>
                <li><a href="#14">14. Yell Channel</a></li>
                <li><a href="#15">15. Vote System</a></li>
                <li><a href="#16">16. Punishment Evasion</a></li>
                <li><a href="#17">17. Alternate Accounts in AFK Zones</a></li>
              </ul>
            </div>
          </div>

          <div class="col-12 col-md-8 col-lg-9">
            <!-- Rule 1 -->
            <h5 class="paragraph--heading" id="1">1. Flaming, Racism, Harassment, and Disrespect</h5>
            <p>
              Xalor is a diverse, global community. To maintain respect, racism, homophobic slurs, harassment, or abusive behavior of any kind will not be tolerated.
              Harassment includes targeting individuals or groups through insults, slander, or repeated unwanted behavior. Using Discord to attack another player or group is also considered harassment.
            </p>
            <div class="row">
              <div class="col-12 col-md-3"><div class="content-box thin"><p>1st Offense</p><p class="status grey">24hr Mute</p></div></div>
              <div class="col-12 col-md-3"><div class="content-box thin"><p>2nd Offense</p><p class="status yellow">48hr Mute</p></div></div>
              <div class="col-12 col-md-3"><div class="content-box thin"><p>3rd Offense</p><p class="status orange">Permanent Mute</p></div></div>
              <div class="col-12 col-md-3"><div class="content-box thin"><p>4th Offense</p><p class="status red">Permanent Ban</p></div></div>
            </div>

            <hr id="2" />
            <h5 class="paragraph--heading">2. Doxing / Sharing Personal Information</h5>
            <p>
              Sharing or exposing personal information (names, addresses, phone numbers, family details, etc.) is strictly forbidden and will result in permanent removal from the community.
            </p>
            <div class="row"><div class="col-12 col-md-3"><div class="content-box thin"><p>1st Offense</p><p class="status red">Permanent IP / Hardware Ban</p></div></div></div>

            <hr id="3" />
            <h5 class="paragraph--heading">3. Advertising Other Servers</h5>
            <p>
              Promoting other servers on Discord or in-game is not allowed. Exceptions may be granted by staff for unrelated communities.
              General platforms (RuneLocus, Rune-Server, YouTube) are permitted as long as they don’t promote another server.
            </p>
            <div class="row">
              <div class="col-12 col-md-3"><div class="content-box thin"><p>1st Offense</p><p class="status red">Permanent Ban</p></div></div>
              <div class="col-12 col-md-3"><div class="content-box thin"><p>2nd Offense</p><p class="status red">IP / MAC Ban</p></div></div>
            </div>

            <hr id="4" />
            <h5 class="paragraph--heading">4. Spamming</h5>
            <p>
              Spamming (clan chat, repeated messages, etc.) is prohibited. Auto-typers must be set to a minimum of 15 seconds between messages.
            </p>
            <div class="row">
              <div class="col-12 col-md-3"><div class="content-box thin"><p>1st Offense</p><p class="status grey">24hr Mute</p></div></div>
              <div class="col-12 col-md-3"><div class="content-box thin"><p>2nd Offense</p><p class="status yellow">48hr Mute</p></div></div>
              <div class="col-12 col-md-3"><div class="content-box thin"><p>3rd Offense</p><p class="status orange">48hr Ban</p></div></div>
              <div class="col-12 col-md-3"><div class="content-box thin"><p>4th Offense</p><p class="status red">Permanent Ban</p></div></div>
            </div>

            <hr id="5" />
            <h5 class="paragraph--heading">5. Hacking & Threats</h5>
            <p>
              Misleading links are not permitted. Hacking (accounts, server, etc.) or making threats of any kind will result in immediate punishment.
              DDoS threats against players or staff will result in permanent removal.
            </p>
            <div class="row"><div class="col-12 col-md-3"><div class="content-box thin"><p>1st Offense</p><p class="status red">Permanent IP Ban</p></div></div></div>

            <hr id="6" />
            <h5 class="paragraph--heading">6. Encouraging Others to Break Rules</h5>
            <p>
              Encouraging or instructing others to break the rules is itself a punishable offense. All players are expected to understand and follow the rules.
            </p>
            <div class="row">
              <div class="col-12 col-md-3"><div class="content-box thin"><p>1st Offense</p><p class="status grey">24hr Ban</p></div></div>
              <div class="col-12 col-md-3"><div class="content-box thin"><p>2nd Offense</p><p class="status yellow">Permanent Mute</p></div></div>
              <div class="col-12 col-md-3"><div class="content-box thin"><p>3rd Offense</p><p class="status red">Permanent Ban</p></div></div>
            </div>

            <hr id="7" />
            <h5 class="paragraph--heading">7. Bug Abuse</h5>
            <p>
              Exploiting bugs or glitches is forbidden. All bugs should be reported immediately to staff.
            </p>
            <div class="row">
              <div class="col-12 col-md-3"><div class="content-box thin"><p>1st Offense</p><p class="status grey">24hr Ban</p></div></div>
              <div class="col-12 col-md-3"><div class="content-box thin"><p>2nd Offense</p><p class="status yellow">72hr Ban</p></div></div>
              <div class="col-12 col-md-3"><div class="content-box thin"><p>3rd Offense</p><p class="status red">Permanent Ban</p></div></div>
            </div>

            <hr id="8" />
            <h5 class="paragraph--heading">8. Player vs Player (PvP)</h5>
            <p>
              PvP is at your own risk. Farming kills using alts or arranged trades for rewards is prohibited, including entering tournaments with alternate accounts.
            </p>
            <div class="row">
              <div class="col-12 col-md-3"><div class="content-box thin"><p>1st Offense</p><p class="status grey">24hr Ban</p></div></div>
              <div class="col-12 col-md-3"><div class="content-box thin"><p>2nd Offense</p><p class="status yellow">72hr Ban</p></div></div>
              <div class="col-12 col-md-3"><div class="content-box thin"><p>3rd Offense</p><p class="status red">Permanent Ban</p></div></div>
            </div>

            <hr id="9" />
            <h5 class="paragraph--heading">9. Third-Party Software</h5>
            <p>
              Cheating of any kind (auto-clickers, bots, cheat clients, etc.) is not tolerated.
            </p>
            <div class="row">
              <div class="col-12 col-md-3"><div class="content-box thin"><p>1st Offense</p><p class="status red">Permanent Ban</p></div></div>
              <div class="col-12 col-md-3"><div class="content-box thin"><p>2nd Offense</p><p class="status yellow">IP Ban</p></div></div>
            </div>

            <hr id="10" />
            <h5 class="paragraph--heading">10. Impersonation</h5>
            <p>
              Pretending to be staff is forbidden and will result in severe punishment.
            </p>
            <div class="row"><div class="col-12 col-md-3"><div class="content-box thin"><p>1st Offense</p><p class="status red">Permanent Ban</p></div></div></div>

            <hr id="11" />
            <h5 class="paragraph--heading">11. Scams, Gambling & Refunds</h5>
            <p>
              Lost items due to disconnects/bugs may be refunded at staff discretion with proof. Donations require proof of purchase for review.
              Scams will result in punishment if clear evidence is provided, though we do not guarantee refunds.
            </p>
            <div class="row">
              <div class="col-12 col-md-3"><div class="content-box thin"><p>1st Offense</p><p class="status red">Permanent Ban</p></div></div>
              <div class="col-12 col-md-3"><div class="content-box thin"><p>2nd Offense</p><p class="status yellow">IP Ban</p></div></div>
            </div>

            <hr id="12" />
            <h5 class="paragraph--heading">12. Real-World Trading (RWT)</h5>
            <p>
              Selling or buying items/services for real-world money, OSRS gold, or any outside payment is prohibited.
              The only exception is the trade of donator pins for OSRS GP. Exploiting loopholes to bypass this rule is also RWT.
            </p>
            <div class="row">
              <div class="col-12 col-md-3"><div class="content-box thin"><p>1st Offense</p><p class="status red">Permanent Ban</p></div></div>
              <div class="col-12 col-md-3"><div class="content-box thin"><p>2nd Offense</p><p class="status yellow">IP Ban</p></div></div>
            </div>

            <hr id="13" />
            <h5 class="paragraph--heading">13. Services</h5>
            <p>
              Xalor does not regulate third-party “services” such as skill training, minigame carries, or inferno services. Use at your own risk.
            </p>

            <hr id="14" />
            <h5 class="paragraph--heading">14. Yell Channel</h5>
            <p>
              Yell chat may be used to advertise clan chats or content creators, but messages must be at least 5 minutes apart.
              Only English may be used in the help channel.
            </p>
            <div class="row">
              <div class="col-12 col-md-3"><div class="content-box thin"><p>1st Offense</p><p class="status grey">24hr Mute</p></div></div>
              <div class="col-12 col-md-3"><div class="content-box thin"><p>2nd Offense</p><p class="status yellow">48hr Mute</p></div></div>
              <div class="col-12 col-md-3"><div class="content-box thin"><p>3rd Offense</p><p class="status red">Permanent Mute</p></div></div>
            </div>

            <hr id="15" />
            <h5 class="paragraph--heading">15. Vote System</h5>

              <p>Abuse of the voting system for unfair advantage will result in a permanent ban.
              Absolutely NO vpn voting.</p>
            <div class="row">
              <div class="col-12 col-md-3"><div class="content-box thin"><p>1st Offense</p><p class="status grey">72hr Ban</p></div></div>
              <div class="col-12 col-md-3"><div class="content-box thin"><p>2nd Offense</p><p class="status yellow">Perm Ban</p></div></div>
              <div class="col-12 col-md-3"><div class="content-box thin"><p>3rd Offense</p><p class="status red">MAC Ban</p></div></div>
          </div>

            <hr id="16" />
            <h5 class="paragraph--heading">16. Punishment Evasion</h5>
            <p>
              Punishments are based on evidence. Attempting to evade a punishment will result in harsher penalties.
              Appeals should be submitted instead of evasion.
            </p>

            <hr id="17" />
            <h5 class="paragraph--heading">17. Alternate Accounts in AFK Zones</h5>
            <p>
              A maximum of 3 alternate accounts may be used in AFK zones at once.
            </p>
            <div class="row">
              <div class="col-12 col-md-3"><div class="content-box thin"><p>1st Offense</p><p class="status grey">72hr Ban</p></div></div>
              <div class="col-12 col-md-3"><div class="content-box thin"><p>2nd Offense</p><p class="status yellow">Permanent Ban</p></div></div>
              <div class="col-12 col-md-3"><div class="content-box thin"><p>3rd Offense</p><p class="status red">IP Ban</p></div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  created() {
    document.title = 'Rules - Xalor'
  }
}
</script>
